import { AddressString } from '~components/providers/types';

import ArbitrumOneDeploymentOutput from '../../abi/ArbitrumOneDeploymentOutput.json';
import {
  BalFarm,
  BoostedFarm,
  ELPType,
  ENativeAsset,
  EOtherAsset,
  EVestaAsset,
  FraxFarm,
  VestaFarm,
} from '../../types';

import { ContractAddresses } from '.';

export const arbitrumContractConfig: ContractAddresses = {
  MultiCall: '0x842eC2c7D803033Edf55E478F461FC547Bc54EB2',
  [ENativeAsset.bVSTA]: '0x',
  [ENativeAsset.VSTA]: ArbitrumOneDeploymentOutput.VSTAToken.address as AddressString,
  [ENativeAsset.VST]: ArbitrumOneDeploymentOutput.VSTToken.address as AddressString,
  [ELPType['VST-USDC']]: '0x',
  [BoostedFarm['VST-USDC']]: '0x',
  [EVestaAsset.wstETH]: '0x5979d7b546e38e414f7e9822514be443a4800529',
  [EVestaAsset.ARB]: '0x912CE59144191C1204E64559FE8253a0e49E6548',
  [EVestaAsset.renBTC]: '0xdbf31df14b66535af65aac99c32e9ea844e14501',
  [EVestaAsset.GMX]: '0xfc5a1a6eb076a2c7ad06ed22c90d7e710e35ad0a',
  [EOtherAsset.vwGMX]: '0x30EFbCA5507d8bC7AB33Cd4EfF5dCbe22a2E61A4',
  [EVestaAsset.DPX]: '0x6c2c06790b3e3e3c38e12ee22f8183b37a13ee55',
  [EOtherAsset.vwDPX]: '0xfF6C71cE5B7E07D36cE850D35088518E9Af171F0',
  [EVestaAsset.sGLP]: '0x2f546ad4edd93b956c8999be404cdcafde3e89ae',
  [EVestaAsset.ETH]: '0x0000000000000000000000000000000000000000',
  [EVestaAsset.gOHM]: '0x8d9ba570d6cb60c7e3e0f31343efe75ab8e65fb1',
  [EOtherAsset.USDC]: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
  [EOtherAsset.DAI]: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
  [EOtherAsset.USDT]: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
  [EOtherAsset.FRAX]: '0x17FC002b466eEc40DaE837Fc4bE5c67993ddBd6F',
  [EOtherAsset.FXS]: '0x9d2F299715D94d8A7E6F5eaa8E654E8c74a988A7',
  [EOtherAsset.fsGLP]: '0x1aDDD80E6039594eE970E5872D247bf0414C8903',
  [EOtherAsset.WETH]: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
  [ELPType['VSTA-ETH']]: '0xc61ff48f94d801c1ceface0289085197b5ec44f0',
  //@TODO replace with actual address when possible
  [ELPType['VST-USDC']]: '0xc61ff48f94d801c1ceface0289085197b5ec44f0',
  [ELPType['VST-FRAX']]: '0x59bF0545FCa0E5Ad48E13DA269faCD2E8C886Ba4',
  [ELPType['VST-USDC-DAI-USDT']]: '0x5A5884FC31948D59DF2aEcCCa143dE900d49e1a3',
  [EOtherAsset.STAKED_4_POOL]: '0x3175B907Cbcf044C0b179958fAFB33e253A44929',
  [EOtherAsset.BAL]: '0x040d1EdC9569d4Bab2D15287Dc5A4F10F56a56B8',
  ActivePool: ArbitrumOneDeploymentOutput.activePool.address as AddressString,
  VaultManager: ArbitrumOneDeploymentOutput.troveManager.address as AddressString,
  MultiVaultGetter: ArbitrumOneDeploymentOutput.multiTroveGetter.address as AddressString,
  PriceFeed: ArbitrumOneDeploymentOutput.priceFeedV2.address as AddressString,
  SortedTroves: ArbitrumOneDeploymentOutput.sortedTroves.address as AddressString,
  StabilityPoolManager: ArbitrumOneDeploymentOutput.stabilityPoolManager.address as AddressString,
  ETHStabilityPool: '0x64cA46508ad4559E1fD94B3cf48f3164B4a77E42',
  renBTCStabilityPool: '0x3282dfAf0fBba4d3E771C4E5F669Cb4E14D8adb0',
  gOHMStabilityPool: '0x6e53D20d674C27b858a005Cf4A72CFAaf4434ECB',
  DPXStabilityPool: '0x0B1Be49dcB62D6cbc27e510361E910a8A30f37A9',
  GMXStabilityPool: '0x78D46Cecf0AE4757F430d95B2d7Eaa18D7087872',
  GLPStabilityPool: '0x2a8b4700E6aA7Ea523c3307fe8b57F0fc8fC5e82',
  ARBStabilityPool: '0x017DE62b40332d47a18033c34F4E68D2419AefDE',
  wstETHStabilityPool: '0x87ead7f8df26e009a6fc127ee91a18f5f94bf489',
  BorrowerOperations: ArbitrumOneDeploymentOutput.borrowerOperations.address as AddressString,
  CollateralSurplusPool: ArbitrumOneDeploymentOutput.collSurplusPool.address as AddressString,
  HintHelpers: ArbitrumOneDeploymentOutput.hintHelpers.address as AddressString,
  CommunityIssuance: ArbitrumOneDeploymentOutput.communityIssuance.address as AddressString,
  VestaParameters: ArbitrumOneDeploymentOutput.vestaParameters.address as AddressString,
  Whitelisting: '0x8691a7833E2644Ce86c1516437F698aDd055d812',
  BalancerVault: '0xBA12222222228d8Ba445958a75a0704d566BF2C8',
  VestingVesta: '0xefD767F55534b09617150434d9e35BFf4b1C96B0',
  VestaNFT: '0xe3c5D8349473Fe81a259257a5B5019493F98C217',
  VestingV1: '0xb889151Da7c8aC6773DE803B0c38018680512cb0',
  VestingV2: '0xefD767F55534b09617150434d9e35BFf4b1C96B0',
  VestaGMXStaking: '0xB9b8f95568D5a305c6D70D10Cc1361d9Df3e9F9a',
  VestaGLPStaking: '0xDB607928F10Ca503Ee6678522567e80D8498D759',
  GMXFeeTracker: '0xd2D1162512F927a7e282Ef43a362659E4F2a728F',
  GLPFeeTracker: '0x4e971a87900b931fF39d1Aad67697F49835400b6',
  VestaGMXBonusStaking: '0x8BFb8e82Ee4569aee78D03235ff465Bd436D40E0',
  GLPManager: '0x321F653eED006AD1C29D174e17d96351BDe22649',
  [VestaFarm['VSTA-ETH']]: ArbitrumOneDeploymentOutput.VestaFarmingVSTA.address as AddressString,
  [VestaFarm['VST-FRAX']]: ArbitrumOneDeploymentOutput.VestaFarmingVST.address as AddressString,
  [FraxFarm.VST_FRAX_GAUGE]: '0x127963A74c07f72D862F2Bdc225226c3251BD117',
  [BalFarm['VST-USDC-DAI-USDT']]: '0x3175B907Cbcf044C0b179958fAFB33e253A44929',
  [BalFarm['V2-VST-USDC-DAI-USDT']]: '0xB395894adC812B4e16120f4d60DB9150Aa04C7E4',
  VSTOracle: '0x46bAc6210DcB43b4269ffe766f31B36267C41EdE',
  ChainlinkBAL: '0xBE5eA816870D11239c543F84b71439511D70B94f',
  ChainlinkFXS: '0x36a121448D74Fa81450c992A1a44B9b7377CD3a5',
  ChainlinkFRAX: '0x0809E3d38d1B4214958faf06D8b1B1a2b73f2ab8',
  ChainlinkUSDC: '0x50834F3163758fcC1Df9973b6e91f0F0F0434aD3',
  ChainlinkDAI: '0xc5C8E77B397E531B8EC06BFb0048328B30E9eCfB',
  ChainlinkUSDT: '0x3f3f5dF88dC9F13eac63DF89EC16ef6e7E25DdE7',
  VestaDexTrader: '0x7ae31D371A0a7189369e5cc79C92FBB11E7598ae',
  VestaInterestManager: '0x0f5d5e424765bf3b49f932f0e9b8e6f3791d33b1',
  ETHInterestRate: '0x3b19ed9c13112cdab31be7972971382f5418f51d',
  gOHMInterestRate: '0x740e3de7bfa7f09b61ab4ce00b59ebd9267af031',
  DPXInterestRate: '0x9f4ac763ce2fd63243edb42d2df8c57ed759699c',
  GMXInterestRate: '0x561d8d0808ee59799a922694c1605f38ea5f6e54',
  GLPInterestRate: '0xf5ecb997039bb1d2c1dd826a7b1609b0fb5a4018',
  ARBInterestRate: '0x0aE073c5135Fc9aa075C6936931849E6a4347168',
  wstETHInterestRate: '0x756434d6d6ddf725279065ea7516f292f8a2373d',
  VestaSavingModule: '0x6c7511f378867225fafea0cc8e862bd344d5d1b0',
  SavingModuleStabilityPool: '0x1c0230Ae9FBC111d7BF0f7d4Fd6D7d8c314c6602',
} as const;
